import { render, staticRenderFns } from "./CardResultado.vue?vue&type=template&id=025961e0&scoped=true"
import script from "./CardResultado.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardResultado.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CardResultado.vue?vue&type=style&index=0&id=025961e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025961e0",
  null
  
)

export default component.exports